export const LISTING_TYPE_PARAM = 'listingType';